<div
	[class.flex-row-reverse]="alignment() === 'right'"
	class="flex w-fit"
	data-test-id="social-proof"
>
	@if (!showOnlyText()) {
		<div
			[class]="
				cn(
					showGradeBackGround() && 'border border-ui-100 bg-ui-50',
					size() === 'base' && 'w-12 text-2xl',
					size() === 'lg' && 'w-16 text-3xl',
					size() === 'sm' && 'w-8 text-base'
				)
			"
			class="flex aspect-square h-0% items-center justify-center rounded font-bold text-accent-125"
			data-test-id="rating"
		>
			{{ rating() | number: '1.1-1' : language() }}
		</div>
	}
	@if (numberOfRatings()) {
		<div
			[class]="
				cn(
					alignment() === 'left' && !showOnlyText() && 'ml-3',
					alignment() === 'right' && 'mr-3',
					alignment() === 'right' && 'text-right',
					size() === 'lg' && 'text-base',
					(size() === 'sm' || size() === 'base') && 'text-sm'
				)
			"
			class="flex flex-col justify-center leading-none"
		>
			<span
				[class]="
					cn(
						size() === 'sm' && 'mb-1',
						size() === 'base' && 'mb-2',
						size() === 'lg' && 'mb-3'
					)
				"
				class="font-bold text-dark-primary"
				data-test-id="rating-text"
			>
				{{
					'components.social-proof.ratings.' + ratingText()
						| translate
				}}
			</span>
			<span class="text-dark-tertiary" data-test-id="number-of-ratings">
				{{ numberOfRatings() | number: '1.0-0' : language() }}
				{{ 'components.social-proof.reviews' | translate }}
			</span>
		</div>
	}
</div>
